import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { IsVisible, LinearLoader } from '../../../utils';

interface ITableRootProps extends HTMLAttributes<HTMLTableElement> {
  isLoading?: boolean;
}

export function TableRoot({
  children,
  className,
  isLoading = false,
  ...rest
}: PropsWithChildren<ITableRootProps>) {
  return (
    <table
      className={twMerge('relative bg-white rounded-lg', className)}
      {...rest}
    >
      <IsVisible when={isLoading}>
        <LinearLoader containerClassName="absolute" />
      </IsVisible>
      {children}
    </table>
  );
}
